module.exports = __webpack_public_path__ + "static/media/evidenceb_logo.86c916ba.png";